type ClientDocumentKind = 'Quote' | 'Actuals';

const filenamePart = (value: unknown): string => {
  if (typeof value !== 'string' && (typeof value !== 'number' || !Number.isFinite(value))) return '';
  return String(value).normalize('NFC')
    .replace(/[\u0000-\u001f\u007f/\\:*?"<>|]+/g, '-')
    .replace(/\s+/g, ' ')
    .replace(/^[\s.-]+|[\s.-]+$/g, '');
};

export const clientDocumentFilename = (
  kind: ClientDocumentKind,
  jobNumber: unknown,
  eventName: unknown
): string => {
  const job = filenamePart(jobNumber);
  const event = filenamePart(eventName);
  return `${[job && `Job ${job}`, event, kind].filter(Boolean).join(' - ')}.pdf`;
};
